/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Contents } from '../../models/contents';
import { ContentsApiRespModel } from '../../models/contents-api-resp-model';

export interface ApiMasterContentApproveRejectPost$Params {
      body?: Contents
}

export function apiMasterContentApproveRejectPost(http: HttpClient, rootUrl: string, params?: ApiMasterContentApproveRejectPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterContentApproveRejectPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsApiRespModel>;
    })
  );
}

apiMasterContentApproveRejectPost.PATH = '/api/Master/Content/ApproveReject';
